import { $api } from '../y/api';
import { yCopy, yEqual, yIsEmpty } from '../y/object';
import { $storage } from '../y/storage';
import { onLogin, onLogout } from './login-event';

const is_available = $storage.is_available;
let preferences: { [key: string]: any } = (is_available && $storage.getObject('preferences')) || {};
let unsaved_preferences: { [key: string]: string } = {};
let is_logged_in = false;

function loadPreferences(prefs: { [key: string]: string }) {
    unsaved_preferences = {};

    const new_preferences: { [key: string]: any } = {}
    for(const key in prefs) {
        new_preferences[key] = JSON.parse(prefs[key]);
    }

    for(const key in preferences) {
        if(!(key in new_preferences)) {
            new_preferences[key] = preferences[key];
            unsaved_preferences[key] = JSON.stringify(preferences[key]);
        }
    }

    preferences = new_preferences;
}

function discardPreferences() {
    preferences = {};
    unsaved_preferences = {};
    $storage.remove('preferences');
}

onLogin(response => {
    loadPreferences(response.user?.preferences ?? {});
    is_logged_in = true;
});

onLogout(() => {
    discardPreferences()
    is_logged_in = false;
});

export function meSetPreference(key: string, value: any) {
    if(yEqual(value, preferences[key])) return;
    preferences[key] = yCopy(value);
    unsaved_preferences[key] = JSON.stringify(value);

    if(is_available)
        $storage.putObject('preferences', preferences, true);
}

export function meGetPreference(key: string, def?: any) {
    const v = preferences[key];
    if(v === undefined)
        return def;
    return yCopy(v);
}

export function meCommitPreferences() {
    if(!yIsEmpty(unsaved_preferences)) {
        if(is_logged_in)
            $api.PUT('me/preferences', unsaved_preferences);
        unsaved_preferences = {};
    }
}

export function meOnce(key: string) {
    if(preferences[key]) return false;
    meSetPreference(key, true);
    meCommitPreferences();
    return true;
}
